// Format eksportu do Asseco Softlab - JEDNO ZRODLO PRAWDY.
//
// Ten modul jest wspoldzielony przez frontend Sovo Pay (src/lib/xlsxGenerator.js)
// i funkcje sovoPayInvoicesApi (functions/), zeby regul formatu nie bylo w repo
// w wielu kopiach. Powod jest empiryczny: xlsx_generator.py to starsza kopia tych
// samych regul i ROZJECHALA SIE - ma zahardkodowane symbol_magazynu="03", nie zna
// rejestru 809 i ma aktywny arkusz MPK, wiec dzis wyprodukowalaby pliki odrzucane
// przez Asseco.
//
// Zasady formatu i 15 udokumentowanych pulapek: KB-xlsx-faktury-sprzedazowe.md.
// Kontrakt API, ktory z tego korzysta: KB-api-sovo-pay-invoices.md.
//
// Modul jest CELOWO niezalezny od srodowiska: uzywa wylacznie XLSX.utils.*, ktore
// dziala tak samo w przegladarce i w Node. Zapis pliku (writeFile), Blob i Buffer
// naleza do wywolujacego - nie dodawaj ich tutaj.
//
// DLACZEGO TEN MODUL LEZY POD functions/: `firebase deploy` wysyla do chmury tylko
// katalog `functions/` (zrodlo z firebase.json), a potem uruchamia tam `npm install`.
// Zaleznosc `file:` wskazujaca poza ten katalog nie zainstalowalaby sie na produkcji.
// Dlatego jedyna kopia zyje tutaj, a frontend siega po nia przez
// "file:functions/shared/asseco-xlsx". Nie przenosic wyzej bez zmiany deployu.
//
// CommonJS, bez skladni wymagajacej transpilacji: react-scripts nie transpiluje
// node_modules, wiec ten plik musi byc zrozumialy dla przegladarki jak stoi.

const XLSX = require('xlsx');

/**
 * XLSX Generator for Sovo Import Format
 * Generates multi-sheet XLSX files matching the accounting system requirements
 */

// Column definitions for each sheet
const DOKUMENTY_COLUMNS = [
  "Identyfikator", "Symbol magazynu", "Symbol rodzaju dowodu", "Numer dowodu w rejestrze",
  "Data dowodu", "Schemat księgowania", "Logo nabywcy/sprzedawcy", "Logo płatnika",
  "Logo odbiorcy/dostawcy", "Numer faktury", "Numer faktury korygująca", "Data VAT",
  "Data sprzedaży", "Data wystawienia", "Symbol waluty", "Baza waluty", "Kurs waluty",
  "Konto", "Symbol Rozrachunku", "Numer Rozrachunku", "Data płatności", "Rodzaj płatności",
  "Opis rozrachunku", "Nazwa kontrahenta", "Pełna nazwa kontrahenta", "Ulica",
  "Kod pocztowy", "Miasto", "Kraj", "NIP", "Symbol stawki VAT linijki",
  "Grupa klasyfikacji VAT", "Grupa odliczeń VAT", "Wartość brutto", "Wartość netto",
  "Wartość VAT", "Wartość brutto w walucie", "Wartość netto w walucie",
  "Wartość VAT w walucie", "Dodatkowy kurs waluty", "Weryfikacja źródła",
  "Podzielona płatność - obowiązkowa", "Podzielona płatność - przelew split payment",
  "Przyczyna korekty", "Szczególny moment VAT", "Data dokumentu", "Walutowa krajowa",
  "Numer z KSeF", "Data z KSeF"
];

const DOWODY_COLUMNS = [
  "Identyfikator", "Symbol magazynu", "Symbol rodzaju dowodu", "Numer dowodu w rejestrze",
  "Data dowodu", "Opis dowodu", "Liczba porządkowa linijki dokumentu", "Opis linijki dowodu",
  "Konto WN", "Konto MA", "Kwota zapisu księgowego", "Kwota walutowa zapisu księgowego",
  "Symbol waluty", "Baza waluty", "Kurs waluty", "Symbol Rozrachunku", "Data rozrachunku",
  "CentrumWn1", "CentrumMa1", "CentrumWn2", "CentrumMa2", "CentrumWn3", "CentrumMa3",
  "CentrumWn4", "CentrumMa4", "Numer zewnętrzny", "WRMK liczba rat",
  "WRMK data pierwszego dowodu", "WRMK data ostatniego dowodu",
  "WRMK zaokrąglenie na pierwszym dowodzie", "WRMK naliczenie propocjonalnie na dzień",
  "WRMK konto przeciwstawne", "Konto WN w źródłowym systemie",
  "Logo kontrahenta dla konta WN w źródłowym systemie", "Konto MA w źródłowym systemie",
  "Logo kontrahenta dla konta MA w źródłowym systemie",
  "WRMK konto przeciwstawne w źródłowym systemie",
  "Logo kontrahenta dla konta przeciwstawnego WRMK w źródłowym systemie",
  "Kwota różnicy pomiędzy wartością bilansową a podatkową",
  "Rodzaj różnicy pomiędzy wartością bilansową a podatkową", "Data CIT"
];

const TERMINARZ_COLUMNS = [
  "Identyfikator", "Liczba porządkowa pozycji terminarza", "Wartość płatności",
  "Wartość płatności w walucie", "Symbol płatności", "Termin płatności",
  "Numer płatności", "Typ płatnosci", "Rachunek bankowy kontrahenta",
  "Sposób naliczania odsetek", "Symbol waluty rachunku bankowego", "Płatność główna",
  "Kontroluj format rachunku", "Sprawdzaj czy istnieje rachunek dla innego kontrahenta",
  "Symbol banku kontrahenta", "Czy zakładać rachunek bankowy", "Waluta płatności"
];

const USLUGI_COLUMNS = [
  "Identyfikator", "Liczba porządkowa linijki usługowej", "Symbol usługi",
  "Opis linijki usługowej", "Symbol PKWiU", "Symbol stawki VAT linijki",
  "Grupa klasyfikacji VAT", "Ilość", "Cena jednostkowa", "Wartość netto linijki",
  "Wartość VAT linijki", "Cena jednostkowa w walucie", "Wartość netto linijki w walucie",
  "Wartość VAT linijki w walucie", "Symbol jednostki miary", "Grupa odliczeń VAT",
  "Symbol dodatkowych kosztów zakupu", "Płatność podzielona", "Kod GTU",
  "Symbol dodatkowej stawki VAT", "Kraj stawki VAT linijki"
];

const MPK_COLUMNS = [
  "Identyfikator", "Liczba porządkowa linijki dowodu",
  "Liczba porządkowa podziału na wymiary kontrolingowe", "Kwota", "Kwota walutowa",
  "Rodzaj wymiaru kontrolingowego", "Wymiar kontrolingowy", "Strona księgowania",
  "Ilość", "Wymiar z systemu źródłowego", "Logo z systemu źródłowego"
];

const JPK_COLUMNS = [
  "Identyfikator", "P_16", "P_17", "P_18", "P_19", "P_19a", "P_19b", "P_19c",
  "P_20", "P_20a", "P_20b", "P_21", "P_21a", "P_21b", "P_21c", "P_22a", "P_22b",
  "P_22c", "P_23", "P_106e_2", "P_106e_3", "P_106e_3a", "P_22", "GTU01", "GTU02",
  "GTU03", "GTU04", "GTU05", "GTU06", "GTU07", "GTU08", "GTU09", "GTU10", "GTU11",
  "GTU12", "GTU13", "SW", "EE", "TP", "TT_WNT", "I_42", "I_63", "B_SPV",
  "B_SPV_DOSTAWA", "B_MPV_PROWIZJA", "IMP", "WSTO_EE", "IED", "SprzedazVAT_Marza",
  "PrzyczynaKorekty", "NrFaKorygowanej", "OkresFaKorygowanej", "TypDokumentu",
  "KorPodstOpodt", "KorPodstOpodt_Termin", "KorPodstOpodt_DataZap"
];

/**
 * Parse Polish address into components
 * Format: "ul. Nazwa 123, 00-000 Miasto" or "ul. Nazwa 123\n00-000 Miasto"
 */
const parseAddress = (address) => {
  const surowy = String(address || '').replace(/\s+/g, ' ').trim();
  if (!surowy) return { ulica: '', kodPocztowy: '', miasto: '' };

  const przytnij = (t) => String(t).replace(/^[\s,;]+|[\s,;]+$/g, '');

  // Kod pocztowy jest jedynym pewnym punktem odniesienia w tych danych.
  const m = surowy.match(/\d{2}-\d{3}/);
  if (!m) return { ulica: surowy, kodPocztowy: '', miasto: '' };

  const kodPocztowy = m[0];
  const przed = przytnij(surowy.slice(0, m.index));
  const po = przytnij(surowy.slice(m.index + kodPocztowy.length));

  // Trzy ksztalty, wszystkie wystepuja w bazie (sprawdzone na 216 adresach):
  //
  //   "ul. Godebskiego 12, 62-800 Kalisz"        -> ulica, kod, miasto
  //   "72-003 Wolczkowo, ulica Polarna numer 9"  -> kod, miasto, ulica  (11 sztuk)
  //   "ul. Malachowskiego 8/23, 61-129"          -> ulica, kod, bez miasta
  //
  // Stara wersja obslugiwala tylko pierwszy. Przy drugim ULICA ZOSTAWALA PUSTA,
  // a cale "Wolczkowo, ulica Polarna numer 9" szlo do pola Miasto. Przy trzecim
  // nie rozpoznawala kodu w ogole i wrzucala wszystko do ulicy.
  if (przed) return { ulica: przed, kodPocztowy, miasto: po };

  // Kod z przodu: po nim idzie miasto, a po pierwszym przecinku ulica.
  const przecinek = po.indexOf(',');
  if (przecinek < 0) return { ulica: '', kodPocztowy, miasto: po };
  return {
    ulica: przytnij(po.slice(przecinek + 1)),
    kodPocztowy,
    miasto: przytnij(po.slice(0, przecinek)),
  };
};

/**
 * Format a date for Asseco import: MM/DD/YYYY (Asseco rejects ISO-8601).
 * Parses a plain YYYY-MM-DD string directly (no Date object) to avoid any
 * timezone drift that could shift the day. Returns '' for empty input.
 */
const formatDateForAsseco = (dateString) => {
  if (!dateString) return '';
  const s = String(dateString).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return dateString;
  return `${m[2]}/${m[3]}/${m[1]}`;
};

// The exact 4 empty KSEF sheets Asseco requires at the end of the workbook.
// Without them Asseco rejects the whole file.
const KSEF_SHEETS = [
  'KSEF DOD. NAGLOWEK',
  'KSEF DOD. LINIJKI',
  'KSEF DOD. USLUGI',
  'KSEF PRACOWNIK',
];
const appendKsefSheets = (wb) => {
  KSEF_SHEETS.forEach((name) => {
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([[]]), name);
  });
};

// Per-company Asseco export config, keyed by the seller NIP carried on each settlement.
// magazyn = company number (= investment.company_id); rodzajDowodu = Asseco document-type symbol.
// rodzajDowodu 809 = osobny rejestr na faktury zaliczkowe (na prośbę księgowości, żeby były
// oddzielone od zwykłej sprzedaży w 209). To TYLKO rejestr - konto należności zostaje 209-10-20.
// Symbol magazynu = numer spółki. Bierzemy go z `company_id` rozliczenia, NIE z tablicy
// kluczowanej NIP-em sprzedawcy: NIP bywał pusty (spółki 02/03/04 nie miały go w bazie),
// przez co dokumenty wychodziły z magazynem 03 niezależnie od spółki i Asseco odrzucało
// import do bufora ("dane zawierają nieprawidłowości"). NIP został wyłącznie jako zapas
// dla starych rozliczeń bez company_id.
const NIP_TO_COMPANY = {
  '7781446354': '02', // Druga (Kamienice Calisia)
  '7781449453': '03', // SOVO Development (Gwiazdowo, Rokietnica)
  '7781454750': '04', // Czwarta (Ogrodowa 12)
  '7781454767': '05', // Piąta (Mosina Sovotel)
  '7781456559': '13', // Dziewiąta (Kutno)
  '7781457240': '15', // Piętnasta (Szczecin)
  '7831704374': '17', // Siedemnasta (Legnica)
  '7831704397': '18', // Osiemnasta (Puszczykowo)
  '7831704405': '20', // Dwudziesta (Rabowice)
};
// Rodzaj dowodu (rejestr) = 809 dla WSZYSTKICH spółek: osobny rejestr faktur zaliczkowych,
// żeby nie mieszały się ze zwykłą sprzedażą. Spółka 03 miała przez chwilę 203 (bo tak
// numeruje faktury pipeline) - Monika potwierdziła 29.07.2026, że 03 też używa 809.
// Uwaga: to rejestr w eksporcie, NIE numeracja faktur. Numery zostają bez zmian
// (203/03/... dla spółki 03, 209/{spółka}/... dla pozostałych).
const REGISTER = '809';

const getExportConfig = (settlement) => {
  const fromId = String(settlement.company_id || '').trim();
  const fromNip = NIP_TO_COMPANY[(settlement.seller_nip || '').trim()];
  const magazyn = (fromId || fromNip || '03').padStart(2, '0');
  return { magazyn, rodzajDowodu: REGISTER };
};

// Wymiar kontrolingowy "Projekt" (rodzaj "PR") - kod PER INWESTYCJA (każda budowa ma swój,
// jak "A0321001-00", "D1324001-00"). Na razie znam tylko Kutno A z dokumentu-wzorca;
// reszta do uzupełnienia od księgowości. Klucz = investment_id z rozliczenia.
// Pełna lista od księgowości (29.07.2026). Format kodu: D{nr spółki}{rok}{kolejny} + "-00",
// np. D0322003-00 = spółka 03, Gwiazdowo F. Dwie cyfry po "D" to numer spółki, więc kod
// można zweryfikować względem company_id inwestycji.
const PROJEKT_CONFIG = {
  'ueVXg3yCaBvXqEshS8Mk': 'D0322001-00', // Gwiazdowo Budynek D
  'aRhGW6TXuFCCJb3TFtgO': 'D0322002-00', // Gwiazdowo Budynek E
  'tTZAsbGj3FKz85e1OE0r': 'D0322003-00', // Gwiazdowo Budynek F
  'uN17ieuHEJjncTlvn2fj': 'D0322004-00', // Gwiazdowo Budynek G
  'y5WxbUtpNUHpwtCA71Aj': 'D0224001-00', // Kamienice Calisia (w słowniku: "Kalisz")
  'aR9xhw3WSKjwCYCiGZt9': 'D1324001-00', // Kutno Budynek A
  'IMbdKYNrhJaDq87KYDHw': 'D1324002-00', // Kutno Budynek B
  'lfgks9z7lwj04vWtdWqM': 'D1725001-00', // Legnica Kossak 17
  '3OrVZNW9Y29m5NZN9mD4': 'D0525001-00', // Mosina Sovotel Budynek A
  'iCT1qFDcwfs8vEUKKABu': 'D0424001-00', // Ogrodowa 12
  'uG1Dy1yHjZa6F0WSpDBH': 'D0326001-00', // Paderewskiego 11 (w słowniku: "Warszawa, ul. Paderewskiego")
  'Oq58qBOVkfNV1DGLP1Hl': 'D1823001-00', // Puszczykowo Ovo Office
  'GX5Oc0ESe9uipPkujoRz': 'D2023001-00', // Rabowice 1
  'bz6cYe9uvViXtM0Uqcgs': 'D2023002-00', // Rabowice 2
  'XtCon0DKOpELiL26p5uM': 'D2023003-00', // Rabowice 3
  'DPa46jwlsULiMoZU0fxe': 'D0324001-00', // Rokietnica A
  'IIbO0zIZL3E14qbpViQz': 'D0324002-00', // Rokietnica B
  'ciuc9sKwWsuw1j0B3nZR': 'D0324003-00', // Rokietnica C
  '2wocaYtEmVwau0xoCSuD': 'D1524001-00', // Szczecin Dąbrowskiego 9
  // BRAK: Szczecin Kolorowych Domów 9 (spółka 15) - nie ma kodu na liście od księgowości.
  // Kutno C (D1324003), Gwiazdowo H-M, Rabowice IV i pozostałe kody dotyczą inwestycji,
  // których nie mamy jeszcze w systemie.
};

/**
 * Create invoice data for XLSX from settlement
 */
const createInvoiceData = (settlement) => {
  const exportCfg = getExportConfig(settlement);
  // NUMER DOWODU W REJESTRZE = ZAWSZE "0", jako TEKST.
  //
  // Bylo tu `invoice_number.split('/').pop()`, czyli NASZ numer kolejny faktury.
  // Asseco nic w tym polu nie wylicza - zapisuje to, co dostanie. Zero znaczy
  // "numer nienadany" i wtedy numeruje samo, znajac stan wlasnego rejestru.
  // Dokument dodany w Asseco recznie ma w tym polu wlasnie 0.
  //
  // DWA SKUTKI starej reguly, oba potwierdzone na wrzesniu 2026, spolka 03:
  //   - DZIURY. Nasz wrzesien ma 81 faktur (numery 1..81), a do Asseco poszla
  //     jedna, numer 69. W rejestrze Asseco widac wiec 27, 28, 50, 69 - bo
  //     numery 29..49 nosza faktury, ktore zostaly u nas jako `pending`.
  //     Wpisywalismy wlasna sekwencje w licznik CUDZEGO rejestru.
  //   - KOLIZJE. Numer, ktory Asseco juz zajelo, blokuje import; tak odbila sie
  //     faktura PGNiG na numerze 47 (eksport kosztowy, 09.2026).
  //
  // Ta sama poprawka poszla wczesniej po stronie kosztowej w Sovo Flow
  // (PR nataszainigra/sovo-flow#50). Sprzedaz zostala wtedy nietknieta.
  const numerWRejestrze = '0';
  const vatRateStr = `${Math.round(settlement.vat_rate * 100)}%`;
  // Identyfikator MUSI być unikatowy - Asseco trzyma na nim unikatowy indeks
  // (AK_imp_LinDokBufor_DokID_ImportName_SymbolSV_...) i przy powtórce przerywa import
  // błędem "Cannot insert duplicate key row". Wcześniejszy schemat {lokal}_E{etap}_{data}
  // dublował się w dwóch sytuacjach: małżeństwo = dwie faktury na ten sam lokal i etap,
  // oraz ten sam kod lokalu w dwóch inwestycjach (np. B16 w Szczecinie i w Kutnie).
  // Numer faktury jest unikatowy z definicji (rejestr/spółka/rok/miesiąc/kolejny) i trwały,
  // więc bierzemy go wprost - tak samo robi sprawdzony eksport w Sovo Flow.
  const identyfikator = String(settlement.invoice_number || '').trim()
    || `${settlement.flat_display_code}_E${settlement.stage_number}_${settlement.date}`;
  // OPIS = investment + flat, e.g. "Mieszkanie Kutno Budynek A, lok. A12".
  const investmentName = String(settlement.investment_name || '').trim();
  const description = investmentName
    ? `Mieszkanie ${investmentName}, lok. ${settlement.flat_display_code}`
    : `Mieszkanie lok. ${settlement.flat_display_code}`;

  // OPIS LINIJKI ZALICZKI MUSI NIESC KOD LOKALU.
  //
  // Z konta 842-10-10-{logo} ksiegowosc wystawia pozniej faktury koncowe i na
  // tej liscie musi widziec, ktore mieszkania zostaly do rozliczenia. Samo
  // "Zaliczka otrzymana" tego nie mowi - przy jednym kontrahencie z kilkoma
  // lokalami nie da sie ich rozroznic. Zgloszenie ksiegowosci z 30.09.2026.
  //
  // Brzmienie wprost z faktury wystawionej recznie w Asseco (rejestr 209),
  // zeby obie drogi opisywaly to samo tak samo.
  const opisZaliczki = `Zaliczka na zakup mieszkania ${settlement.flat_display_code} `
    + 'zgodnie z umową deweloperską';
  // All document dates = the actual settlement/payment date (e.g. 2026-07-07):
  // data wystawienia = data sprzedaży = data VAT = data płatności. Previously these
  // were clamped to the export day, so every date wrongly showed up as "today".
  const invoiceDate = settlement.date;
  // Asseco contractor code (logo), matched per client from the Asseco dictionary.
  // Drives the buyer link, the receivables account (209-10-20-{logo}) and the
  // advance account (842-10-10-{logo}). Empty until the client's logo is set.
  const logo = String(settlement.asseco_logo || '').trim();
  const kontoNaleznosci = logo ? `209-10-20-${logo}` : '';
  const kontoZaliczki = logo ? `842-10-10-${logo}` : '';
  const projektCode = PROJEKT_CONFIG[settlement.investment_id] || '';

  // Parse address into components
  const { ulica, kodPocztowy, miasto } = parseAddress(settlement.client_address);

  return {
    dokumenty: {
      "Identyfikator": identyfikator,
      "Symbol magazynu": exportCfg.magazyn,
      "Symbol rodzaju dowodu": exportCfg.rodzajDowodu,
      "Numer dowodu w rejestrze": numerWRejestrze,
      "Logo nabywcy/sprzedawcy": logo,
      "Logo płatnika": logo,
      "Logo odbiorcy/dostawcy": logo,
      "Konto": kontoNaleznosci,
      "Data dowodu": formatDateForAsseco(invoiceDate),
      "Numer faktury": settlement.invoice_number,
      "Data VAT": formatDateForAsseco(invoiceDate),
      // "Data sprzedaży" stays raw YYYY-MM-DD - Asseco reads this column as-is
      // (matches the proven Sovo Flow export; it is the one date-column exception).
      "Data sprzedaży": invoiceDate,
      "Data wystawienia": invoiceDate,
      "Symbol waluty": "PLN",
      "Baza waluty": 1,
      "Kurs waluty": 1,
      "Nazwa kontrahenta": settlement.client_name,
      "Pełna nazwa kontrahenta": settlement.client_name,
      "Ulica": ulica,
      "Kod pocztowy": kodPocztowy,
      "Miasto": miasto,
      "Kraj": "PL",
      "NIP": settlement.client_nip || "",
      "Symbol stawki VAT linijki": vatRateStr,
      "Opis rozrachunku": description,
      "Wartość netto": settlement.amount_netto,
      "Wartość VAT": settlement.amount_vat,
      "Wartość brutto": settlement.amount_brutto,
      "Data płatności": formatDateForAsseco(invoiceDate),
      // Sposob platnosci: 'ZAL', symbol slownikowy pozycji "zaliczka", podany
      // przez ksiegowosc 06.10.2026.
      //
      // WCZESNIEJ BYLO 'Po' I BYLO ZLE PODWOJNIE. Wzielismy ten symbol 14.09.2026
      // z dzialajacego eksportu sprzedazy w Sovo Flow, gdzie oznacza "zaplacono"
      // i dotyczy zwyklych faktur sprzedazowych. Po pierwsze znaczyl co innego niz
      // trzeba - to jest faktura ZALICZKOWA. Po drugie w ogole sie nie stosowal:
      // na dokumentach w Asseco pole zostawalo PUSTE, a nie wypelnione slowem
      // "zaplacono". Gdyby symbol byl poprawny, Asseco by go pokazalo.
      //
      // Czego nie zauwazylismy przez trzy tygodnie: 14.09 sprawdzilismy zawartosc
      // PLIKU, a nie skutek w Asseco. Plik mial wartosc, wiec wygladalo na zrobione.
      //
      // MUSI BYC KROTKI SYMBOL, nie pelne slowo. Kolumna `rodzajp` ucina dluzsza
      // wartosc, a ucieta wywala przerzucanie dokumentu z bufora do rejestru
      // (Sovo Flow, 08.09.2026).
      "Rodzaj płatności": "ZAL"
    },
    // DOWODY - dekretacja faktury zaliczkowej sprzedaży (schemat potwierdzony przez
    // księgowość): WN 209-10-20-{logo} = brutto (należność), MA 222-10-30 = VAT,
    // MA 842-10-10-{logo} = netto (zaliczka otrzymana, NIE przychód). Emitowane
    // tylko, gdy znamy logo klienta - inaczej DOWODY zostaje samym nagłówkiem, żeby
    // nigdy nie księgować na konto "209-10-20-" bez kontrahenta.
    dowody: logo ? [
      {
        "Identyfikator": identyfikator,
        "Symbol magazynu": exportCfg.magazyn,
        "Symbol rodzaju dowodu": exportCfg.rodzajDowodu,
        "Numer dowodu w rejestrze": numerWRejestrze,
        "Data dowodu": formatDateForAsseco(invoiceDate),
        "Opis dowodu": description,
        // Liczby porzadkowe jako TEKST, nie liczba - Asseco odrzuca wiersz
        // z wartoscia numeryczna (udokumentowane w eksporcie kosztowym
        // i sprzedazowym Sovo Flow).
        "Liczba porządkowa linijki dokumentu": "1",
        "Opis linijki dowodu": "Należność brutto",
        "Konto WN": kontoNaleznosci,
        "Symbol Rozrachunku": settlement.invoice_number,
        "Kwota zapisu księgowego": settlement.amount_brutto,
        "Symbol waluty": "PLN"
      },
      {
        "Identyfikator": identyfikator,
        "Symbol magazynu": exportCfg.magazyn,
        "Symbol rodzaju dowodu": exportCfg.rodzajDowodu,
        "Numer dowodu w rejestrze": numerWRejestrze,
        "Data dowodu": formatDateForAsseco(invoiceDate),
        "Opis dowodu": description,
        "Liczba porządkowa linijki dokumentu": "2",
        "Opis linijki dowodu": "VAT należny",
        "Konto MA": "222-10-30",
        "Kwota zapisu księgowego": settlement.amount_vat,
        "Symbol waluty": "PLN"
      },
      {
        "Identyfikator": identyfikator,
        "Symbol magazynu": exportCfg.magazyn,
        "Symbol rodzaju dowodu": exportCfg.rodzajDowodu,
        "Numer dowodu w rejestrze": numerWRejestrze,
        "Data dowodu": formatDateForAsseco(invoiceDate),
        "Opis dowodu": description,
        "Liczba porządkowa linijki dokumentu": "3",
        "Opis linijki dowodu": opisZaliczki,
        "Konto MA": kontoZaliczki,
        "Symbol Rozrachunku": settlement.invoice_number,
        "Kwota zapisu księgowego": settlement.amount_netto,
        "Symbol waluty": "PLN"
      }
    ] : [],
    terminarz: {
      "Identyfikator": identyfikator,
      // Jak wyzej: tekst, nie liczba. Odrzucony wiersz terminarza znaczy brak
      // terminu platnosci na fakturze w Asseco - zgloszenie ksiegowej z 14.09.2026.
      "Liczba porządkowa pozycji terminarza": "1",
      "Wartość płatności": settlement.amount_brutto,
      "Wartość płatności w walucie": settlement.amount_brutto,
      "Symbol płatności": "P7",
      "Termin płatności": invoiceDate,
      // Left blank on purpose: on a sales document Asseco validates any account
      // here as the company's OWN bank account and rejects posting if it is not
      // registered (proc fk7_checkzalozrachunkiedittmp). The per-flat escrow
      // account is not (and should not be) in Asseco's own-account dictionary.
      // The proven Sovo Flow export also leaves this empty.
      "Rachunek bankowy kontrahenta": "",
      "Płatność główna": 1
    },
    // USLUGI = the FK "fakturowanie" tab (invoice line). On sales it does NOT
    // auto-fill from the document (unlike costs), so we supply it here.
    // "Symbol usługi" left blank (STAGE was not a registered Asseco service symbol).
    // "Kod GTU" / "Symbol jednostki miary" pending Monika's values.
    uslugi: {
      "Identyfikator": identyfikator,
      // Pola całkowite jako TEKST ("1") - Asseco czyta komórkę liczbową jako "1.0"
      // i przy konwersji na INT wywala "Conversion failed ... '1.0' to int".
      "Liczba porządkowa linijki usługowej": "1",
      // Support Asseco (2026-07-16): kolumna SymUsl w imp_LinUslEditTmp jest NOT NULL,
      // więc "Symbol usługi" nie może być puste (INSERT fails z NULL). Wartość do
      // potwierdzenia przez Monikę - czy taka jest OK, czy musi być kod ze słownika.
      "Symbol usługi": "ZALICZKA",
      "Opis linijki usługowej": description,
      "Symbol stawki VAT linijki": vatRateStr,
      // Odwzorowane 1:1 z poprawnej linii na dokumencie-wzorcu:
      "Grupa klasyfikacji VAT": "SK",
      "Ilość": "1",
      "Cena jednostkowa": settlement.amount_netto,
      "Wartość netto linijki": settlement.amount_netto,
      "Wartość VAT linijki": settlement.amount_vat,
      // Support Asseco (2026-07-15): "IMP_USL Błąd w linii [1], kolumna [12]: [Puste
      // pole]". Kolumna 12 (licząc od 1) = "Cena jednostkowa w walucie" - nie może być
      // pusta. Faktura jest w PLN, więc kwoty walutowe = kwoty złotowe. Sąsiednie 13/14
      // wypełniam z tego samego powodu, żeby nie wywalił się na kolejnej.
      "Cena jednostkowa w walucie": settlement.amount_netto,
      "Wartość netto linijki w walucie": settlement.amount_netto,
      "Wartość VAT linijki w walucie": settlement.amount_vat,
      "Symbol jednostki miary": "szt",
      "Kod GTU": "10",
      "Kraj stawki VAT linijki": "PL"
    },
    // Wymiary kontrolingowe (tablica wierszy MPK-sheet). MPK (MP/magazyn+100) USUNIĘTE -
    // te wartości nie istnieją w słowniku Asseco (log walidacji) i nie są wymagane.
    // Wymiar "Projekt" (PR), kod per inwestycja, na linii zaliczki (842 = linia 3).
    // Tylko gdy jest dekret (logo) i znamy kod projektu dla tej inwestycji.
    // TODO "Transakcje powiązane" = "ND" (linie 1 i 3) - czeka na symbol rodzaju importu.
    // WYŁĄCZONE 31.07.2026. Wymiar blokuje przerzucenie dokumentu do rejestru:
    // "Wybrany wymiar [D0322004-00] dla rodzaju [MP], firmy [103] i roku [2027] nie istnieje
    // lub nie jest czynny" - Asseco sprawdza rok 2027 dla dokumentu z 08.06.2026, mimo że
    // otwarty rok obrotowy to 2026. Sprawdzone: nie wynika z formatu daty (faktura z dnia 8,
    // gdzie MM/DD i DD/MM dają ten sam rok, daje identyczny komunikat) ani z rodzaju wymiaru
    // (PR = ciche pominięcie, MP = walidacja). Bez arkusza MPK dokumenty przechodzą do rejestru.
    // Czeka na odpowiedź supportu Asseco - wtedy wystarczy przywrócić `true &&` poniżej.
    mpk: (false && logo && projektCode) ? [{
      "Identyfikator": identyfikator,
      "Liczba porządkowa linijki dowodu": 3,
      "Liczba porządkowa podziału na wymiary kontrolingowe": 1,
      "Kwota": settlement.amount_netto,
      "Rodzaj wymiaru kontrolingowego": "PR",
      "Wymiar kontrolingowy": projektCode,
      "Strona księgowania": 2
    }] : [],
    jpk: {
      "Identyfikator": identyfikator
    }
  };
};

/**
 * Create a row with all columns, filling missing ones with null
 */
const createRow = (data, columns) => {
  const row = {};
  columns.forEach(col => {
    row[col] = data[col] !== undefined ? data[col] : null;
  });
  return row;
};

/**
 * Generate XLSX file from list of settlements
 * @param {Array} settlements - Array of settlement objects
 * @param {string} filename - Output filename
 */
// Build the full 10-sheet Asseco workbook from a list of settlements.
const buildWorkbook = (settlements) => {
  const allDokumenty = [];
  const allDowody = [];
  const allTerminarz = [];
  const allUslugi = [];
  const allMpk = [];
  const allJpk = [];

  settlements.forEach(settlement => {
    const data = createInvoiceData(settlement);
    allDokumenty.push(createRow(data.dokumenty, DOKUMENTY_COLUMNS));
    data.dowody.forEach(d => allDowody.push(createRow(d, DOWODY_COLUMNS)));
    allTerminarz.push(createRow(data.terminarz, TERMINARZ_COLUMNS));
    allUslugi.push(createRow(data.uslugi, USLUGI_COLUMNS));
    data.mpk.forEach(m => allMpk.push(createRow(m, MPK_COLUMNS)));
    allJpk.push(createRow(data.jpk, JPK_COLUMNS));
  });

  const wb = XLSX.utils.book_new();
  // DOWODY carries rows only for settlements whose client logo is known; otherwise
  // just the header (so we never emit a dekret without a contractor account).
  const wsDowody = allDowody.length
    ? XLSX.utils.json_to_sheet(allDowody, { header: DOWODY_COLUMNS })
    : XLSX.utils.aoa_to_sheet([DOWODY_COLUMNS]);

  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(allDokumenty, { header: DOKUMENTY_COLUMNS }), 'DOKUMENTY');
  XLSX.utils.book_append_sheet(wb, wsDowody, 'DOWODY');
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(allTerminarz, { header: TERMINARZ_COLUMNS }), 'TERMINARZ');
  // USLUGI = the FK "fakturowanie" tab (invoice service line), mirrored 1:1 from the
  // correct June reference document. Still rejected by IMP_USL for an unknown field -
  // need the exact "Log walidacji" message (run "Waliduj" in Asseco) to finish it.
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(allUslugi, { header: USLUGI_COLUMNS }), 'USLUGI');
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(allMpk, { header: MPK_COLUMNS }), 'MPK');
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(allJpk, { header: JPK_COLUMNS }), 'JPK');

  // Required empty KSEF sheets - Asseco rejects the file without them
  appendKsefSheets(wb);
  return wb;
};

module.exports = {
  // Jedyne publiczne wejscie: zwraca obiekt workbooka SheetJS. Wywolujacy decyduje,
  // co z nim zrobi (writeFile w przegladarce / Buffer w Node).
  buildWorkbook,
  // Ponizsze wystawione do testow i weryfikacji zgodnosci naglowkow.
  DOKUMENTY_COLUMNS,
  DOWODY_COLUMNS,
  TERMINARZ_COLUMNS,
  USLUGI_COLUMNS,
  MPK_COLUMNS,
  JPK_COLUMNS,
  getExportConfig,
  formatDateForAsseco,
};
